<div class="Time-box Time-box-lg" *ngIf="DateTime != null">
  <p class="m-0 ms-2 animate__animated animate__fadeInDown animate__delay-6-0s">
    <span>
      {{ time }}
    </span>
    <i class="bx bx-time"></i>
    |
  </p>

  <p class="m-0 ms-2 animate__animated animate__fadeInDown animate__delay-5-6s">
    <span>
      {{ date | date : "yyyy/MM/dd" }}
    </span>
    <i class="bx bx-globe"></i>
    |
  </p>
  <p class="m-0 ms-2 animate__animated animate__fadeInDown animate__delay-5-2s">
    <span>
      {{ DateTime | persianDate }}
    </span>
    <i class="bx bx-calendar"></i>
    |
  </p>
</div>
<div class="Time-box Time-box-sm" *ngIf="DateTime != null">
 
    <span class="border-bottom animate__animated animate__fadeInDown animate__delay-5-2s">
      {{ date | date : "yyyy/MM/dd" }}
      <i class="bx bx-globe"></i>
    </span>
    <span class="animate__animated animate__fadeInDown animate__delay-5-6s">
      {{ DateTime | persianDate }}
      <i class="bx bx-calendar"></i>
    </span>
  
</div> 

